/* 引用字典的类型
    字典来源于后端数据
 * @Author: houxingzhang
 * @Date: 2019-07-22 11:11:03
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2019-09-29 18:40:18
 */

export default {
  BUS_CHARGE_TYPE: 'busChargeType', // 客车收费类型
  BUS_OR_TRUCK: 'busOrTruck', // 客货标识
  CHARGE_TYPE: 'chargeType', // 收费方式
  DEVICE_TYPE: 'deviceType', // 设备类型
  ESCAPE_TYPE: 'escapeType', // 逃费类型
  LANE_TYPE: 'laneType', // 车道类型
  ROLE_LEVEL: 'roleLevel', // 角色层级
  SPECIAL_CHARGE_TYPE: 'specialChargeType', // 专项作业车收费类型
  STATION_TYPE: 'stationType', // 收费站类型
  TRUCK_CHARGE_TYPE: 'truckChargeType', // 货车收费类型
  UP_OR_DOWN_TYPE: 'upOrDownType', // 上下行、双向
  USER_STATUS: 'userStatus', // 用户状态
  REGION_TYPE: 'RegionType', // 区域类型
  CHECK_STATUS: 'checkStatus', // 审核状态
  CHECK_RESULT: 'checkResult', // 审核结果
  JUDGE_DODGE: 'judgeDodge', // 稽查结论
  PURSUE_STATUS: 'pursueStatus', // 追缴状态
  BLACKLIST_TYPE: 'blacklistType', // 黑名单库类型
  DATA_SOURCE: 'dataSource', // 数据来源
  VEHICLE_LIB: 'vehicleLib', // 库类型
  SUSPICIOUS_TYPE: 'suspiciousType', // 事件类型
  PLATE_COLOR: 'plateColor', // 车牌颜色
  PLATE_PREFIX: 'platePrefix', // 省份简称
  YES_OR_NO: 'YesOrNo', // 是否类型
  STATUS: 'status', // 状态
  USER_TYPE: 'userType', // 用户类型
  SEX: 'userSex',
  LOG_TYPE: 'operType', // 日志类型
  VEHICLE_CLASS: 'VehicleClass', // 收费类型
  CARCOLOR: 'CarColor', // 车身颜色
  HW_CHARGE_TYPE: 'hwChargeType', // 高速收费类型
  ABNORMALEVENT: 'abnormalevent', // 异常事件原因
  EVENTTYPE: 'EventType', // 事件类型
  POORSTATUS: 'PoorStatus', // 图片质量监测状态
  MOBILEDEVICE_TYPE: 'mobileDeviceType', // 移动设备状态
  ENABLEORDISABLE: 'EnableOrDisable', // 启用/禁用
  ROADCOMPANYUNIT_TYPE: 'RoadCompanyUnitType', // 路段公司单位类型
  FEEDBACKSTATUS: 'feedbackStatus', // 问题反馈状态
  LOGAPPQUERY_CHECKTYPE: 'LogAppqueryCheckType',
  STATION_DIRECTION: 'StationDirection', // 门架方向
  ROAD_START_END: 'RoadStartEnd', // 路段的起始虚拟站
  Examine_Status: 'ExamineStatus', // vip稽查审核状态
  IsNormalDealStatus: 'IsNormalDealStatus', // vip稽查卡片状态
  IsNormalDealStatusAdmin: 'IsNormalDealStatusAdmin' // vip稽查卡片管理员状态
}



// WEBPACK FOOTER //
// ./src/commons/dictionaryType.js